import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { verificarAcessoUsuario } from '../utils/authStandards';

export default function AcessoRestrito({ modulo, children }) {
  const temAcesso = verificarAcessoUsuario(modulo);

  if (!temAcesso) {
    return (
      <Box
        sx={{
          height: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => 
            theme.palette.mode === 'dark' 
              ? theme.palette.background.default 
              : theme.palette.grey[50]
        }}
      >
        <Box
          sx={{
            maxWidth: 600,
            width: '90%',
            textAlign: 'center',
            p: 4
          }}
        >
          <LockIcon 
            sx={{ 
              fontSize: 80, 
              color: 'warning.main',
              mb: 2
            }} 
          />
          <Alert 
            severity="warning" 
            sx={{ 
              mb: 2,
              textAlign: 'left'
            }}
          >
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
              Acesso Restrito
            </Typography>
            <Typography variant="body1">
              Seu perfil de usuário não tem acesso a esse módulo, solicite o apoio de um Administrador.
            </Typography>
          </Alert>
        </Box>
      </Box>
    );
  }

  return <>{children}</>;
} 